{ key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },{ key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },<script>
import CountriesApi from "@/services/countries-api";
import UsersApi from "@/services/users-api";
import CustomerApi from "@/services/customers-api";


export default {
      components: {},
  data() {
    return {
        usersFilter:null,
        usersList: [],
        customersList:[],
        customersFilter:null,
        pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
        customersListFields: 
            [
                
                { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                { key:"extId", label: "Code",   sortable: false, tdClass:"font-weight-bold ",},


                { key:"category", label: "Type",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },

                { key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"city", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},
                // { key:"phone", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"address", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                     

                { key:"isUrgentOrder", label: "",   sortable: false, tdClass:"font-weight-bold ",},

                { key:"isCustomerBlocked", label: "Blocage ERP",   sortable: false, tdClass:"font-weight-bold ",},

                { key:"users", label: "",thClass:"text-center", tdClass:"text-center"},    

                { key:"token", label: "",thClass:"text-center", tdClass:"text-center"},

                { key:"status", label: "",thClass:"text-center", tdClass:"text-center"},

                { key: "actions", label: "", thStyle:"min-width:90px;"}
            ],
        type:null,
        isCustomersTableBusy:false,
        showDetailsModal:false,
        showConditionsModal:false,
        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,
        if_form_error:false,
        showForm:false,
        selectedUser:{id:'',name:'',userName:'',password:'',supplierId:null,status:1, extSystemId:''},
        showUsersModal:false,
        isNew:false,
        selectedUserList:[],
        isPasswordChange:false,
        newPassword:null,
        selected:{country:"",city:""},    
        passwordHidden:true,
        showTraderModal:false,
        tradersList:[],
        selectedTrader:null,
        selectedPDF:null,
        gotTradersList:false,
        validateProfile: false,
        showAccessibleAgencyModal:false,
        savingAccessibleAgencies:[],
      }
      
    },

    
  mounted() {
    this.findCustomers()
    this.getCountries()
  },

    computed: {

    showCustomerInfo() {
      return process.env.VUE_APP_FEATURE_CUSTOMER_INFO === 'true';
    },

    agencyList() {
    try {
        const featureAgencies = JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");

        const accessibleAgencies = (this.getAccessibleAgencies() || []).filter(agency => typeof agency === 'object');
        const agencies = [...featureAgencies, ...accessibleAgencies];
        const uniqueAgencies = [];
        const agencyIds = new Set();

        agencies.forEach(agency => {
          const agencyId = this.getAgencyDbId(agency);
          if (agencyId == null || !agencyIds.has(agencyId)) {
            if (agencyId != null) {
              agencyIds.add(agencyId);
            }
            uniqueAgencies.push(agency);
          }
        });

        return uniqueAgencies;
    } catch (e) {
        return this.getAccessibleAgencies() || [];
    }
    },

    hasAgencyList() {
      return this.agencyList && this.agencyList.length > 0;
    },
  },


  methods: {

    exportUserList(){
        UsersApi.exportUserList()
    },

    validateCustomerInfo() {
      if(this.selected && this.selected.id) {
        CustomerApi.validateCustomerInfo(this.customersFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedCountry ? this.selectedCountry.id : null,this.selectedCity ? this.selectedCity.id : null, this.validateProfile,this.selected.id).then(
            response => {
                if(response) {
                this.customersList= response.list
                this.pagemodelMain.totalRows = response.total;
                this.pagemodelMain.currentPage = response.page;
                this.pagemodelMain.perPage = response.pageSize;
                this.pagemodelMain.pageSize = response.pageSize;
                this.showDetailsModal=false;
            }   
            }
        )
      }
    },

    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
          result => {
            this.citiesList = result
        })
     },
    
    findCustomers(){
          this.isCustomersTableBusy = true;
              CustomerApi.getAllCustomersWithUsersCount(this.customersFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedCountry ? this.selectedCountry.id : null,this.selectedCity ? this.selectedCity.id : null, this.validateProfile).then(
                  response => {
                      if(response) {
                        this.customersList= response.list
                        this.pagemodelMain.totalRows = response.total;
                        this.pagemodelMain.currentPage = response.page;
                        this.pagemodelMain.perPage = response.pageSize;
                        this.pagemodelMain.pageSize = response.pageSize;
                    }   
                  }
              )
              .finally(() => {
             this.isCustomersTableBusy = false;

      });
    },

    deliveryModeToLabel(deliveryMode){
      switch(deliveryMode) {
        case 0: return 'supplier';
        case 1: return 'carrier';
        default: return 'supplier';
      }
    },

    getTraders(){
        UsersApi.getAllTraders().then(
            (result)=>{
                this.tradersList=result
                this.gotTradersList=true
            }
        )
    },


    saveTraderToCustomer(){
      if(this.selectedTrader==null){
        this.selectedTrader={name:''}
      }
      this.selectedTrader.customerId= this.selected ? this.selected.id : null
      UsersApi.saveTraderToCustomer(this.selectedTrader).then(
        (result)=> {
            if(result){
                this.showTraderModal=false       
            }

        }
      )
    },


    getTrader(item){
        if(!this.gotTradersList){
            this.getTraders()
        }
        this.selected=item;
        UsersApi.getTrader(this.selected ? this.selected.id : null).then(
            (result)=>{
                if(result && result.id){
                    this.selectedTrader=result
                }else{
                    this.selectedTrader=null
                }
                
                this.showTraderModal=true

            }
        )
    },

    openAccessibleAgencyModal(item) {
      this.selected = item;
      this.showAccessibleAgencyModal = true;
    },

    getAgencyDbId(agency) {
      if (!agency) {
        return null;
      }

      if (typeof agency === 'string') {
        return agency;
      }

      const dbAgencyId = agency.id;
      return dbAgencyId == null ? null : String(dbAgencyId);
    },

    getAgencyLabel(agency) {
      if (!agency) {
        return '';
      }
      return agency.name;
    },

    getAccessibleAgencies() {
      const accessibleAgency = this.selected && this.selected.accessibleAgency;
      if (accessibleAgency && Array.isArray(accessibleAgency.agenceSecondary)) {
        return accessibleAgency.agenceSecondary;
      }
      return this.selected && Array.isArray(this.selected.agenceSecondary) ? this.selected.agenceSecondary : [];
    },

    getMainAgencyId() {
      const accessibleAgency = this.selected && this.selected.accessibleAgency;
      const mainAgency = accessibleAgency && accessibleAgency.agence != null
        ? accessibleAgency.agence
        : this.selected && this.selected.agence;
      if (mainAgency == null || mainAgency === '') {
        return null;
      }
      return String(mainAgency);
    },

    isMainAgency(agency) {
      return this.getMainAgencyId() === this.getAgencyDbId(agency);
    },

    isAgencySelected(agency) {
      const agencyId = this.getAgencyDbId(agency);
      return this.isMainAgency(agency) || this.getAccessibleAgencies().some(
        accessibleAgency => this.getAgencyDbId(accessibleAgency) === agencyId
      );
    },

    isAccessibleAgencySaving(agency) {
      return this.savingAccessibleAgencies.includes(this.getAgencyDbId(agency));
    },

    setAccessibleAgencies(result) {
      const accessibleAgency = result && !Array.isArray(result) && result.agenceSecondary
        ? result
        : { agence: this.getMainAgencyId(), agenceSecondary: Array.isArray(result) ? result : [] };
      this.$set(this.selected, 'accessibleAgency', accessibleAgency);
      const customer = this.customersList.find(customer => customer.id === this.selected.id);
      if(customer){
          this.$set(customer, 'accessibleAgency', accessibleAgency);
      }
    },

    toggleAccessibleAgency(agency){
      const dbAgencyId = this.getAgencyDbId(agency);
      if(!this.selected || !this.selected.id || !dbAgencyId || this.isMainAgency(agency) || this.isAccessibleAgencySaving(agency)) {
          return;
      }

      this.savingAccessibleAgencies.push(dbAgencyId);
      CustomerApi.addOrRemoveAccessibleAgency(this.selected.id, dbAgencyId).then(
          (result) =>{
                if(result){
                    this.setAccessibleAgencies(result);
                }
          }
      ).finally(() => {
          this.savingAccessibleAgencies = this.savingAccessibleAgencies.filter(id => id !== dbAgencyId);
      })
    },

    onPDFUpload(id){
      if(!this.selectedPDF) {
          return;
      }
      const fd = new FormData();
      fd.append('file', this.selectedPDF, this.selectedPDF.name)
      CustomerApi.saveFilePDF(fd,id).then(
          () =>{
                this.findCustomers();

                }
      ).finally(
          this.selectedPDF=null
      )
    },

    // downloadPaymentConditions(fileName){
    //   CustomerApi.downloadPaymentConditions(fileName)
    // }

},

    watch: {
        selectedCountry: function(){
          if(this.selectedCountry != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
            this.findCustomers()
        },

        selectedCity: function(){
            this.findCustomers()

        },
        validateProfile: function(){
            this.findCustomers()
        }
    }



};
</script>
<style>

    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

    .agency-modal {
      position: relative;
      padding: 0;
    }

    .agency-modal-close {
      position: absolute;
      top: -8px;
      right: -6px;
      width: 28px;
      height: 28px;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: #8a94a6;
      font-size: 20px;
      line-height: 1;
      cursor: pointer;
    }

    .agency-modal-close:hover {
      color: #111827;
    }

    .agency-modal-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 14px;
    }

    .agency-modal-header__icon {
      width: 52px;
      height: 52px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2f5bea;
      background: #eaf0ff;
      box-shadow: inset 0 0 0 1px rgba(47, 91, 234, 0.04);
      font-size: 22px;
      flex: 0 0 auto;
    }

    .agency-modal-header__body {
      min-width: 0;
      flex: 1;
    }

    .agency-modal-header__title {
      color: #111827;
      font-size: 18px;
      font-weight: 800;
      line-height: 1.1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .agency-modal-header__subtitle {
      color: #667085;
      font-size: 13px;
      margin-top: 4px;
    }

    .agency-modal-counter {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 9px 14px;
      border-radius: 10px;
      background: #e7f7ef;
      color: #047857;
      font-size: 12px;
      font-weight: 800;
      white-space: nowrap;
    }

    .agency-modal-counter__number {
      font-size: 18px;
      line-height: 1;
    }

    .agency-modal-info {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      padding: 10px 14px;
      border: 1px solid #dbe7ff;
      border-radius: 8px;
      background: #eef5ff;
      color: #2f4f87;
      font-size: 13px;
      font-weight: 600;
    }

    .agency-modal-info__icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background: #3867dc;
      flex: 0 0 auto;
      font-size: 11px;
    }

    .agency-list {
      border: 1px solid #e6ebf2;
      border-radius: 8px;
      overflow: hidden;
      background: #fff;
      max-height: 300px;
      overflow-y: auto;
    }

    .agency-row {
      width: 100%;
      min-height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 10px 18px 10px 16px;
      border: 0;
      border-bottom: 1px solid #e6ebf2;
      background: #fff;
      text-align: left;
      cursor: pointer;
      transition: background 0.15s ease;
    }

    .agency-row:last-child {
      border-bottom: 0;
    }

    .agency-row:hover {
      background: #f8fafc;
    }

    .agency-row--selected {
      background: #f0fbf5;
    }

    .agency-row--saving {
      cursor: progress;
      opacity: 0.75;
    }

    .agency-row--main {
      cursor: default;
    }

    .agency-row__left {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    .agency-row__icon {
      width: 34px;
      height: 34px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f0f3f9;
      color: #64748b;
      font-size: 15px;
      flex: 0 0 auto;
    }

    .agency-row__content {
      min-width: 0;
    }

    .agency-row__name {
      color: #111827;
      font-size: 14px;
      font-weight: 800;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .agency-row__badge {
      display: inline-flex;
      align-items: center;
      width: max-content;
      margin-top: 4px;
      padding: 3px 9px;
      border-radius: 7px;
      background: #dff7ee;
      color: #047857;
      font-size: 11px;
      font-weight: 700;
    }

    .agency-row__right {
      min-width: 86px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      flex: 0 0 auto;
    }

    .agency-switch {
      width: 46px;
      height: 26px;
      border-radius: 999px;
      padding: 3px;
      background: #c3cad6;
      transition: background 0.15s ease;
    }

    .agency-switch__knob {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: block;
      background: #fff;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.18);
      transition: transform 0.15s ease;
    }

    .agency-switch--on {
      background: #139b63;
    }

    .agency-switch--on .agency-switch__knob {
      transform: translateX(20px);
    }

    .agency-row__status {
      color: #667085;
      font-size: 11px;
      font-weight: 600;
      white-space: nowrap;
    }

    @media (max-width: 576px) {
      .agency-modal-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 14px;
    }

      .agency-modal-header__icon {
      width: 52px;
      height: 52px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2f5bea;
      background: #eaf0ff;
      box-shadow: inset 0 0 0 1px rgba(47, 91, 234, 0.04);
      font-size: 22px;
      flex: 0 0 auto;
    }

      .agency-modal-header__title {
      color: #111827;
      font-size: 18px;
      font-weight: 800;
      line-height: 1.1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

      .agency-modal-counter {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 9px 14px;
      border-radius: 10px;
      background: #e7f7ef;
      color: #047857;
      font-size: 12px;
      font-weight: 800;
      white-space: nowrap;
    }

      .agency-row {
      width: 100%;
      min-height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 10px 18px 10px 16px;
      border: 0;
      border-bottom: 1px solid #e6ebf2;
      background: #fff;
      text-align: left;
      cursor: pointer;
      transition: background 0.15s ease;
    }

      .agency-row__right {
      min-width: 86px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      flex: 0 0 auto;
    }
    }
</style>
<template>


    



    <div class="row pt-4 mt-4">    
      <div class="col-sm-12">
        <div class="">
          <div class="">
           

            <div class="row p-0 m-0 pb-2 mt-0">
                <div class ="col-xl-4 col-lg-4 col-md-12 col-cm-12 col-xs-12 ">
                    <b-form-group label="Filtrer par nom ou code client" >
                        <b-input-group  >
                            <b-form-input :placeholder="$t('subscription.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="findCustomers() "
                                ></b-form-input>                              
                            <template v-slot:append>
                                <b-button variant="primary" @click="findCustomers()" >
                                <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                                </b-button>
                            </template>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class ="col-xl-2 col-lg-2 "/>
                <div class ="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <b-form-group :label="$t('lists.countries.filter')" label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="countriesList" :placeholder="$t('lists.countries.label')"  label="name" v-model="selectedCountry">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-0">
                    <b-form-group :label="$t('lists.cities.filter')"  label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>


            <div v-if="showCustomerInfo" class="form-group mt-2 mb-5 d-flex align-items-center">
            <b-form-checkbox
                value="1"
                unchecked-value="0"
                v-model="validateProfile"
                class="custom-checkbox custom-checkbox-success mb-0 mt-0 d-flex align-items-center"
            >
                <span :class="validateProfile == true ? 'text-success' : 'text-muted'">
                {{ $t('subscription.nameFilter.validateProfile') }}
                </span>
            </b-form-checkbox>

            <span 
                v-if="validateProfile == true" 
                class="ml-2 cursor-pointer" 
                @click.stop="exportUserList()"
                style="cursor: pointer;"
            >
                <img src="@/assets/images/download-success.svg" height="17" />
            </span>
            </div>

            <div class="table-responsive"> 
                <b-table 
                :busy="isCustomersTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="customersList"
                :fields="customersListFields"
                :perPage="pagemodelMain.perPage"
                class="table  "
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>
                <template v-slot:head(companyName)>
                    {{ $t("subscription.table.name") }} 
                </template>
                <template v-slot:head(country)>
                    {{ $t("subscription.table.country") }} 
                </template>
                <template v-slot:head(city)>
                    {{ $t("subscription.table.city") }} 
                </template>
                <template v-slot:head(extId)>
                    {{ $t("subscription.table.code") }} 
                </template>

                <template v-slot:head(isUrgentOrder)>
                    Type Cmde
                </template>

                <template v-slot:head(phone)>
                    {{ $t("subscription.table.phone") }} 
                </template>
                <!-- <template v-slot:head(paymentConditions)>
                    {{ $t("subscription.table.paymentConditions") }} 
                </template> -->
                <template v-slot:head(status)>
                   Actif 
                </template>
                <template v-slot:head(users)>
                    {{ $t("subscription.table.users") }} 
                </template>
                 <template v-slot:head(trader)>
                    {{ $t("subscription.table.trader") }} 
                </template>
                <template v-slot:cell(status)="{value}">
                    <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
                </template>

                <template v-slot:cell(isUrgentOrder)="{value}">
                    <b-badge href="#" class="font-weight-bold" :variant="value ? 'primary' : 'light'">{{ value ? 'Urgente' : 'Normale' }}</b-badge>
                </template>

                <template v-slot:cell(isCustomerBlocked)="{value}">
                    <b-badge href="#" class="font-weight-bold" :variant="value ? 'danger' : 'light'">{{ value ? 'Bloqué' : '' }}</b-badge>
                </template>

                

                <template v-slot:cell(country)="{value}">
                    {{value.name}}
                </template>
                
                <template v-slot:cell(city)="{value}">
                    {{value.name}}
                </template>

                <template v-slot:cell(category)="{value}">
                    {{value ===0 ? 'Officine' : value === 1 ? "Para" : "Clinique"}}
                </template>

                <template v-slot:cell(users)="{item}">
                    <a :href="'/customer-utilisateurs?id=' + item.id">
                        {{ item.usersCount }} utilisateur(s)
                        </a>
                
<!--    <span :class="item.usersCount ? 'text-success font-weight-bold' : 'text-muted'" @click="selected=item;hideForm();isPasswordChange=false;getUserInfo(item.id);" style="cursor:pointer" :title="item.usersCount + ' utilisateurs actifs'" > <i class="fas fa-users-cog font-weight-bold mr-2 font-size-14" /> {{ item.usersCount }} utilisateur(s)</span>
 -->               </template>
                <template v-slot:cell(actions)="{item}">
                    <i class="fas fa-info-circle text-info font-weight-bold font-size-16 mr-3" style="cursor:pointer" :title="$t('subscription.showDetails')" @click="selected=item;showDetailsModal=true" ></i>
                    <i v-if="hasAgencyList" class="fas fa-building text-primary font-weight-bold font-size-16" style="cursor:pointer" title="Agences accessibles" @click="openAccessibleAgencyModal(item)" ></i>
                </template>
                <template v-slot:cell(trader)="{item}">
                    <i class="fas fa-user-tie text-primary font-weight-bold font-size-16" style="cursor:pointer" :title="$t('subscription.showTrader')" @click="getTrader(item)" ></i>
                </template>
                <!-- <template v-slot:cell(paymentConditions)="{item}">

                    <label   :for="String(item.id)+'ref'" class="css-class">
                        <i v-b-tooltip.hover :title="$t('subscription.paymentConditions.upload')" class="fas fa-upload text-info font-size-16 mr-3" style="cursor:pointer"></i>
                        <b-form-file v-model="selectedPDF"  :id="String(item.id)+'ref'"   @input="onPDFUpload(item.id)" style="display:none"></b-form-file>
                    </label>
                    <a v-bind:style="[item.paymentConditionsPDF ? {'visibility':'visible'} :{'visibility':'hidden'}]"  @click.prevent="downloadPaymentConditions(item.paymentConditionsPDF)" 
                    class="action-icon font-size-12 font-weight-bold text-info mr-3" :title="$t('subscription.paymentConditions.download')"  style="cursor:pointer">
                    {{$t('subscription.paymentConditions.label')+item.name }}
              </a>
                </template> -->
                </b-table>
                <span v-if="!isCustomersTableBusy & !customersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
            </div>
            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findCustomers()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodelMain.currentPage" :disabled="isCustomersTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findCustomers()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->
            

          </div>
        </div>
      </div>


    <b-modal v-if="selected"
    v-model="showDetailsModal"
        :title="$t('subscription.detailsModal.title')"
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        hide-footer
>

       


        <div class="row mb-4 mt-2 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-user-tie font-size-16 mr-2"/>{{$t('subscription.detailsModal.name')}} </span>
              <br/><span class="font-size-14">{{selected.name == null ? "-" : selected.name}}</span>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-phone font-size-16 mr-2"/>{{$t('subscription.detailsModal.phone')}}</span>
              <br/><span class="font-size-14">{{selected.phone == null ? "-" : selected.phone}}</span>
            </div>

            <!-- <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-primary font-weight-bold "><i class="fas fa-coins font-size-16 mr-2"/>{{$t('subscription.detailsModal.inProgress')}}</span>  
                <br/><span class="font-size-14">{{selected.inProgress== null ? "-" : selected.inProgress}}</span>
            </div> -->

        </div>

        <div class="row mt-4 mb-4 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold "><i class="fa fa-industry font-size-16 mr-2"/>{{$t('subscription.detailsModal.companyName')}}</span>  
              <br/><span class="font-size-14">{{selected.companyName == null ? "-" :  selected.companyName}}</span>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-envelope font-size-16 mr-2"/>{{$t('subscription.detailsModal.mail')}}</span>
              <br/><span class="font-size-14">{{selected.mail== null ? "-" :selected.mail }}</span>
            </div>

            <!-- <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-primary font-weight-bold "><i class="fas fa-credit-card font-size-16 mr-2"/>{{$t('subscription.detailsModal.ceiling')}}</span>  
                <br/><span class="font-size-14">{{selected.ceiling == null ? "-" : selected.ceiling}}</span>
            </div> -->

        </div>

        <div class="row mt-4 mb-2 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-hashtag font-size-16 mr-2"/>{{$t('subscription.detailsModal.code')}}</span>
              <br/><span class="font-size-14">{{selected.extId == null ? "-" :selected.extId   }}</span>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-flag font-size-16 mr-2"/>{{$t('subscription.detailsModal.country')}}</span>
              <br/><span class="font-size-14">{{selected.country == null ? "-" : selected.country.name == null ? "-" : selected.country.name }}</span>
            </div>

            <!-- <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-primary font-weight-bold "><i class="fas fa-percent font-size-16 mr-2"/>{{$t('subscription.detailsModal.currency')}}</span>  
                <br/><span class="font-size-14">{{selected.currency == null ? "-" :selected.currency }}</span>
            </div> -->

 
        </div>

        <div class="row mt-4 mb-2 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.address')}}</span>
              <br/>
                <span class="font-size-14" v-if="selected.addresses && selected.addresses.length">
                <div v-for="(address, index) in selected.addresses" :key="index">
                    - {{ address }}<span v-if="index < selected.addresses.length - 1">, </span>
                </div>
                </span>
                <span class="font-size-14" v-else>-</span>
                </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.city')}}</span>
              <br/><span class="font-size-14">{{selected.city.name == null ? "-" : selected.city.name == null ? "-" : selected.city.name }}</span>
            </div>

            <!-- <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-primary font-weight-bold "><i class="fas fa-question font-size-16 mr-2"/>{{$t('subscription.detailsModal.taxRefNumber')}}</span>  
                <br/><span class="font-size-14">{{selected.taxRefNumber == null ? "-" :selected.taxRefNumber   }}</span>
            </div> -->

        </div>

        <div class="row mt-4 mb-2 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-briefcase font-size-16 mr-2"/>{{$t('subscription.detailsModal.taxRefNumber')}}</span>
              <br/><span class="font-size-14">{{selected.taxRefNumber == null ? "-" :selected.taxRefNumber   }}</span>
            </div>

            <div v-if="!(showCustomerInfo && selected.updateProfileDate)" class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-envelope font-size-16 mr-2"/>{{$t('subscription.detailsModal.invoiceMail')}}</span>
                <br/><span class="font-size-14">{{selected.invoiceAddressMail== null ? "-" :selected.invoiceAddressMail }}</span>
            </div>
        </div>

        <div class="row mt-4 mb-2 ml-4">
            <div v-if="selected.pharmacyType" class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.pharmacyType')}}</span>
                <br/><span class="font-size-14">{{selected.pharmacyType== null ? "-" :selected.pharmacyType }}</span>
            </div>
        </div>

        <div v-if="showCustomerInfo && selected.updateProfileDate" class="mt-4 mb-4 ml-4">

          <hr class="mx-auto" style="max-width: 95%;" />

            <div class="row">

                <div class="col-6">

                    <div class="text-danger font-size-14 font-weight-bold">
                        Demande de modification de profil
                    </div>

                    <div>
                        <small class="text-danger">
                            Dernière date de modification :
                            {{ selected.updateProfileDate || '—' }}
                        </small>
                    </div>

                </div>

                <div class="col-6">

                     <b-button v-if="showCustomerInfo" variant="outline-danger" @click="validateCustomerInfo()" class="float-right text-uppercase" :disabled="selected.updateProfileDate == null || selected.invoiceTaxRefNumber == null || selected.invoiceTaxRefNumber.trim() == '' || !selected.invoiceAddressMail == null || selected.invoiceAddressMail.trim() == ''">
                        {{$t('subscription.detailsModal.validateCustomerInfo')}}
                    </b-button>

                </div>


            </div>
            

            <div class="row mt-3">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-dark font-weight-bold "><i class="fas fa-briefcase font-size-16 mr-2"/>{{$t('subscription.detailsModal.taxRefNumber')}}</span>  
                <br/><span class="font-size-14">{{selected.invoiceTaxRefNumber == null ? "-" :  selected.invoiceTaxRefNumber}}</span>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-envelope font-size-16 mr-2"/>{{$t('subscription.detailsModal.invoiceMail')}}</span>
                <br/><span class="font-size-14">{{selected.invoiceAddressMail== null ? "-" :selected.invoiceAddressMail }}</span>
            </div>

            </div>

           

        </div>

    </b-modal>

    <b-modal v-if="selected"
    v-model="showAccessibleAgencyModal"
        centered
        title-class="text-primary"
        header-close-variant="danger"
        hide-footer
        hide-header
>

        <div class="agency-modal">
            <button type="button" class="agency-modal-close pb-4" aria-label="Fermer" @click="showAccessibleAgencyModal=false">&times;</button>
            <div class="agency-modal-header pt-2">
                <div class="agency-modal-header__icon">
                    <i class="fas fa-building"></i>
                </div>
                <div class="agency-modal-header__body">
                    <div class="agency-modal-header__title">{{ selected.companyName || selected.name }}</div>
                    <div class="agency-modal-header__subtitle">Gestion des accès aux agences</div>
                </div>
                <div class="agency-modal-counter">
                    <span class="agency-modal-counter__number">{{ getAccessibleAgencies().length }}</span>
                    <span>agence(s) autorisée(s)</span>
                </div>
            </div>

            <div class="agency-modal-info">
                <span class="agency-modal-info__icon"><i class="fas fa-info"></i></span>
                <span>Sélectionnez les agences auxquelles ce client peut accéder.</span>
            </div>

            <div class="agency-list">
                <button
                    v-for="agency in agencyList"
                    :key="getAgencyDbId(agency)"
                    type="button"
                    :disabled="isMainAgency(agency) || isAccessibleAgencySaving(agency)"
                    :class="['agency-row', { 'agency-row--selected': isAgencySelected(agency), 'agency-row--saving': isAccessibleAgencySaving(agency), 'agency-row--main': isMainAgency(agency) }]"
                    @click="toggleAccessibleAgency(agency)">
                    <div class="agency-row__left">
                        <div class="agency-row__icon"><i class="fas fa-building"></i></div>
                        <div class="agency-row__content">
                            <div class="agency-row__name">{{ getAgencyLabel(agency) }}</div>
                            <div v-if="isMainAgency(agency)" class="agency-row__badge">Agence principale</div>
                        </div>
                    </div>
                    <div class="agency-row__right">
                        <b-spinner v-if="isAccessibleAgencySaving(agency)" small></b-spinner>
                        <span v-else :class="['agency-switch', { 'agency-switch--on': isAgencySelected(agency) }]">
                            <span class="agency-switch__knob"></span>
                        </span>
                        <span class="agency-row__status">{{ isMainAgency(agency) ? 'Autorisé' : isAgencySelected(agency) ? 'Autorisé' : 'Non autorisé' }}</span>
                    </div>
                </button>
            </div>

            <div class="d-flex justify-content-end mt-4">
                <b-button variant="outline-secondary" @click="showAccessibleAgencyModal=false">Fermer</b-button>
            </div>
        </div>

    </b-modal>
    </div>


</template>